"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var urls = require('common/urls');
var archivnrsCtrl = function($scope, $uibModalInstance, $q, $http, archivnrsParams) {
  var init = function() {
    $scope.urls = urls;
    $scope.query = archivnrsParams.archivnr;
    $scope.per_page = 6;
    $scope.page = 1;
    $scope.count = 0;
    getList();
  };
  $scope.selectArchivnr = function(id) {
    angular.forEach($scope.works, function(value, key) {
      value.isSelected = false;
      if (value.archivnr[0] == id) {
        value.isSelected = true;
      }
    });
  };
  $scope.$watch('showBildnrs', function() {
    if ($scope.showBildnrs == true) {
      init();
    }
  });
  $scope.refresh = function() {
    $scope.page = 1;
    getList();
  };
  $scope.save = function() {
    var archivnr = null;
    angular.forEach($scope.works, function(value, key) {
      if (value.isSelected == true) {
        archivnr = value;
      }
    });
    $uibModalInstance.close(archivnr);
  };
  $scope.$watch('page', function() {
    getList();
  });
  var getList = function() {
    $scope.loading = true;
    var params = {
      "query": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    $http.get('/api/ensemble/autocomplete.json', {params: params}).success(function(data, status, headers, config) {
      $scope.works = data.works;
      $scope.count = data.count;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      $scope.selectArchivnr($scope.identifier);
    });
  };
  init();
};
archivnrsCtrl.$inject = ['$scope', '$uibModalInstance', '$q', '$http', 'archivnrsParams'];
module.exports = archivnrsCtrl;
